import { render } from "./MobileNavigationToggle.vue?vue&type=template&id=2a222914"
import script from "./MobileNavigationToggle.vue?vue&type=script&lang=js"
export * from "./MobileNavigationToggle.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__